const t = {
  "cdr-button": "cdr-button_15-0-1",
  "cdr-button--has-icon-left": "cdr-button--has-icon-left_15-0-1",
  "cdr-button--has-icon-right": "cdr-button--has-icon-right_15-0-1",
  "cdr-button--primary": "cdr-button--primary_15-0-1",
  "cdr-button--secondary": "cdr-button--secondary_15-0-1",
  "cdr-button--dark": "cdr-button--dark_15-0-1",
  "cdr-button--sale": "cdr-button--sale_15-0-1",
  "cdr-button--link": "cdr-button--link_15-0-1",
  "cdr-button--large": "cdr-button--large_15-0-1",
  "cdr-button--medium": "cdr-button--medium_15-0-1",
  "cdr-button--small": "cdr-button--small_15-0-1",
  "cdr-button--icon-only": "cdr-button--icon-only_15-0-1",
  "cdr-button--icon-only-large": "cdr-button--icon-only-large_15-0-1",
  "cdr-button--with-background": "cdr-button--with-background_15-0-1",
  "cdr-button--full-width": "cdr-button--full-width_15-0-1",
  "cdr-button--small@xs": "cdr-button--small@xs_15-0-1",
  "cdr-button--medium@xs": "cdr-button--medium@xs_15-0-1",
  "cdr-button--large@xs": "cdr-button--large@xs_15-0-1",
  "cdr-button--full-width@xs": "cdr-button--full-width@xs_15-0-1",
  "cdr-button--small@sm": "cdr-button--small@sm_15-0-1",
  "cdr-button--medium@sm": "cdr-button--medium@sm_15-0-1",
  "cdr-button--large@sm": "cdr-button--large@sm_15-0-1",
  "cdr-button--full-width@sm": "cdr-button--full-width@sm_15-0-1",
  "cdr-button--small@md": "cdr-button--small@md_15-0-1",
  "cdr-button--medium@md": "cdr-button--medium@md_15-0-1",
  "cdr-button--large@md": "cdr-button--large@md_15-0-1",
  "cdr-button--full-width@md": "cdr-button--full-width@md_15-0-1",
  "cdr-button--small@lg": "cdr-button--small@lg_15-0-1",
  "cdr-button--medium@lg": "cdr-button--medium@lg_15-0-1",
  "cdr-button--large@lg": "cdr-button--large@lg_15-0-1",
  "cdr-button--full-width@lg": "cdr-button--full-width@lg_15-0-1"
};
export {
  t as default
};
